import events from 'events-bus';
import { useState, useEffect } from 'react';

import { Cart } from '../types';
import { GET_CART_EVENT, ADD_TO_CART_EVENT } from '../utils/constants';

const DEFAULT_CART: Cart = {
    summary: { articleCount: 0 },
};

export function useCart(): [Cart] {
    const [cart, setCart] = useState(DEFAULT_CART);

    useEffect(() => {
        const updateCart = (_eventName: string, data: { response: Cart }) => {
            setCart(data.response ?? DEFAULT_CART);
        };
        events.on(GET_CART_EVENT, updateCart);
        events.on(ADD_TO_CART_EVENT, updateCart);

        return () => {
            events.off(updateCart);
        };
    }, []);

    return [cart];
}
